import { VIEW_ADVOCATE_PAGE } from '@constants/amplitudeEvents';
import { FeatureFlagsType, ReferralCampaignFeatureFlagType } from '@context/FeatureFlagContext';
import { useEvents } from '@events/EventsProvider';
import { getExperimentValue } from '@utils/amplitudeSSR';
import React, { useEffect } from 'react';

export async function getServerSideProps(context: any) {
  const [referralCampaignFlag] = await Promise.all([
    getExperimentValue<FeatureFlagsType>(context, 'referral-campaign').catch(() => null),
  ]);

  const referralCampaign = (referralCampaignFlag || 'original') as ReferralCampaignFeatureFlagType;

  if (referralCampaign !== 'sale') {
    return {
      redirect: {
        permanent: false,
        destination: '/',
      },
    };
  }

  return {
    props: {
      referralCampaign,
    },
  };
}

export default function Advocate() {
  const { track } = useEvents();
  useEffect(() => {
    track(VIEW_ADVOCATE_PAGE, {});
  }, [track]);
  return <div id="friendbuylandingpage" />;
}
